export const environment = {
  production: false,
  apiBaseUrl: '/api',
  showDefault: false,
  // Temporary flag: show the per-type day total summary above daily charts.
  showDaySummary: true,
  // After an optimizer run, load the schedule generated from the active solution (GET optimizer/schedule).
  loadGeneratedSchedule: false,
  locale: 'de-AT',
};
